export const HEADER = {
  headerLogo: {
    ariaLabel: 'MattressFirm',
    homepageUrl: '/',
    iconURL: '/makeapayment/icons/payment-header/logo.svg',
    iconAlt: 'mfrm-logo',
  },
  title: {
    label: 'Make A Payment',
  },
};
